import { useEffect, useSyncExternalStore } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  WELCOME_PATH, onSignUpChange, reachScreen, signUpAwaitingWelcome, welcomeTarget,
} from '../lib/adConversions';

// The two thank-you pages' routing (#754): a new account goes to /welcome by
// whichever door made it, and each screen the router shows is reported to
// src/lib/adConversions.js, which decides whether it is a conversion.
//
// Mounted in App.jsx inside AuthProvider and outside SignInGate, because an
// email sign-up is unconfirmed when it lands: the gate draws the
// check-your-email screen at /welcome, and the sign-up still counts — the
// account exists — while the welcome screen waits for the address to be
// confirmed.
//
// The redirect waits for the signed-in user: /welcome is behind RequireAuth,
// and the auth observer can publish the user after the sign-in call has
// resolved (AuthContext's device claim), so going early would bounce through
// /login. PublicOnly sends a new account the same way, so the sign-in page's
// own redirect does not race this one to Home.
export function useThankYouPages() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const awaiting = useSyncExternalStore(onSignUpChange, signUpAwaitingWelcome);

  useEffect(() => {
    if (user && awaiting && pathname !== WELCOME_PATH) navigate(welcomeTarget(), { replace: true });
  }, [user, awaiting, pathname, navigate]);

  useEffect(() => {
    // The Checkout session id is read once and taken out of the address, so
    // a refresh, the back button or a bookmark brings no second one.
    if (reachScreen(pathname, search)) navigate({ pathname, search: '', hash }, { replace: true });
  }, [pathname, search, hash, navigate]);
}
